import type { IObjectiveWhatIsImportantForYou } from './ObjectiveWhatIsImportantForYou.interface';
import { ImportantOption } from '../global/ImportantOption.enum';
import { FrequencyOption } from '../global/FrequencyOption.enum';

export default class ObjectiveWhatIsImportantForYou implements IObjectiveWhatIsImportantForYou {
  lowestOverallLoanCost: ImportantOption;
  lowestOverallLoanCostComments: string;
  loanApprovedQuickly: ImportantOption;
  loanApprovedQuicklyComments: string;
  specificLoanFeatures: ImportantOption;
  specificLoanFeaturesComments: string;
  lenderPolicy: ImportantOption;
  lenderPolicyComments: string;
  goToBranch: FrequencyOption;
  useInternetBanking: FrequencyOption;
  importantRepaymentsAndFees: number;
  loanApproved: number;

  static build = (data: IObjectiveWhatIsImportantForYou) =>
    new ObjectiveWhatIsImportantForYou(data);

  static blank = () => new ObjectiveWhatIsImportantForYou();

  /**
   * Constructor
   * @param {IObjectiveWhatIsImportantForYou} data
   */
  constructor(data?: IObjectiveWhatIsImportantForYou) {
    this.lowestOverallLoanCost = ImportantOption.of(
      data?.lowestOverallLoanCost?.name || `i${data?.lowestOverallLoanCost}`
    );
    this.lowestOverallLoanCostComments = data?.lowestOverallLoanCostComments || '';
    this.loanApprovedQuickly = ImportantOption.of(
      data?.loanApprovedQuickly?.name || `i${data?.loanApprovedQuickly}`
    );
    this.loanApprovedQuicklyComments = data?.loanApprovedQuicklyComments || '';
    this.specificLoanFeatures = ImportantOption.of(
      data?.specificLoanFeatures?.name || `i${data?.specificLoanFeatures}`
    );
    this.specificLoanFeaturesComments = data?.specificLoanFeaturesComments || '';
    this.lenderPolicy = ImportantOption.of(
      data?.lenderPolicy?.name || `i${data?.lenderPolicy}`
    );
    this.lenderPolicyComments = data?.lenderPolicyComments || '';
    this.goToBranch = FrequencyOption.of(
      data?.goToBranch?.name || data?.goToBranch?.toString()
    );
    this.useInternetBanking = FrequencyOption.of(
      data?.useInternetBanking?.name || data?.useInternetBanking?.toString()
    );
    this.importantRepaymentsAndFees = parseInt(data?.importantRepaymentsAndFees || 0, 10);
    this.loanApproved = parseInt(data?.loanApproved || 0, 10);
  }
}
